import { makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'

export default makeStyles(
	(theme: Theme) => ({
		modalContentContainer: {
			backgroundColor: '#F4F5F5',
			padding: '16px',
			borderRadius: '8px',
		},
	}),
	{ index: 1 },
)
